import React, { useEffect, useReducer, useState } from "react";
import { useNavigate } from "react-router-dom";
import { useDispatch } from "react-redux";
import { PUSHER_CRED, URLS } from "../../_config";
import { useForm } from "react-hook-form";
import Icon from "../../components/icons";
import {
  useStoreSelector,
  useAuthStatus,
  useStoreBrnDSSelector,
} from "../../store/selectors/userSelector";
import { useStoreApi } from "../../store/api/hooks/storeApiHook";
import { useDataSourceApi } from "../../store/api/hooks/dataSourceApiHook";
import toast from "react-hot-toast";
import SideMenuBar from "../../components/sideMenuBar";
import { Paginator } from "primereact/paginator";
import Header from "../../components/header";
import { showDate, truncateString } from "../../_common/functions";
import DataSourceStatus from "../../components/dataSource/DataSourceStatus";
import { usePusherDataSelector } from "../../store/selectors/pusherSelector";
import { PusherResponse } from "../../_config/interfaces/interfaces";

const DataSources: React.FC = () => {
  const [datasources, setDatasources] = useState<any[]>([]);
  const [first, setFirst] = useState(1);
  const [perPage, setPerpage] = useState(10);
  const [page, setPage] = useState(1);
  const [isPagination, setIsPagination] = useState<boolean>(false);
  const [totalcount, setTotalCount] = useState(0);
  const [isAddBtnDisabled, setIsAddBtnDisabled] = useState<boolean>(false);

  const storeAPI: any = useStoreApi();
  const dataSourceAPI = useDataSourceApi();
  const navigate = useNavigate();
  const isAuth = useAuthStatus();
  const store = useStoreSelector();
  const branchDS = useStoreBrnDSSelector();
  const dispatch = useDispatch();
  const pusherData = usePusherDataSelector();

  const {
    register,
    formState: { errors },
    handleSubmit,
  } = useForm<any>();

  const getDataSources = (param: any) => {
    let params: any;
    if (param) {
      params = {
        branch_id: branchDS?.branch_id,
        page: Math.floor(first / perPage) + 1,
        page_size: perPage,
        ...param,
      };
    } else {
      params = {
        branch_id: branchDS?.branch_id,
        page: Math.floor(first / perPage) + 1, // Page is 1-based, adjust accordingly
        page_size: perPage,
      };
    }
    dataSourceAPI.getDataSource(
      params,
      (msg: any, resp: any) => {
        // console.log('resp =>', resp.data);
        setDatasources(resp.data);
        setTotalCount(resp.pagination?.total_records || 0);
        setIsPagination(true);
      },
      (err: any) => {
        toast.error(err);
      }
    );
  };

  const handlePageChange = (e: any) => {
    const newPage = e.page;
    const newFirst = e.first;
    const newRows = e.rows;

    if (newFirst !== first || newRows !== perPage) {
      setPage(newPage);
      setPerpage(perPage);
      setFirst(newFirst);

      let params: any;
      // if (filterValue) {
      //     params = {
      //         branch_id: branchDS?.branch_id, page: newPage + 1,
      //         page_size: perPage, ...filterValue
      //     };
      // } else {
      params = {
        branch_id: branchDS?.branch_id,
        page: newPage + 1,
        page_size: perPage,
      };
      // }
      getDataSources(params);
    }
  };

  useEffect(() => {
    getDataSources({});
  }, []);

  useEffect(() => {
    const isLoading = pusherData.some((item: PusherResponse) =>
      item.status === "processing" || item.status === "fetching"
    );
    setIsAddBtnDisabled(isLoading);
  },[pusherData]);
  // console.log("isAddBtnDisabled", {isAddBtnDisabled, pusherData});

  return (
    <div className="flex">
      <SideMenuBar
        sideMenuBarClass={"w-64 h-auto w-1/6 bg-white min-h-screen "}
      />

      <div className="w-full w-5/6 bg-sky-50">
        <Header />
        <div className="p-8">
          <h1 className="text-xl font-semibold text-gray-600 mb-4">
            DataSources
          </h1>

          {/* Paragraph */}
          <p className="text-sm text-gray-600 mb-6">
            {/* Reviews With Text.Learn More */}
            Text Reviews Overview
          </p>

          {/* Card Component */}
          <div className="bg-white shadow-lg rounded-2xl p-6 mb-5">
            <div className="flex justify-between items-center mb-4">
              <h2 className="text-lg font-semibold text-gray-700">
                Data Source List
              </h2>

              {/* Buttons */}
              <div className="flex space-x-2">
                <Icon
                  name="add"
                  size="24"
                  className={"text-white text-sm p-3 rounded-full " + (isAddBtnDisabled ? "pointer-events-none bg-blue-200" : "bg-blue-500 hover:bg-blue-600")}
                  onClick={() => { if (!isAddBtnDisabled) { navigate(URLS.DATASOURCES.CREATE); } return null; }}
                />

                <Icon
                  name="refresh"
                  size="24"
                  className="bg-blue-500 hover:bg-blue-600 text-white text-sm p-3 rounded-full"
                  onClick={() => getDataSources({})}
                />
              </div>
            </div>
            <div className="overflow-x-auto">
              <table className="min-w-full table-auto">
                <thead>
                  <tr className="bg-gray-100 border-b">
                    <th className="px-6 py-3 text-left text-xs font-medium text-gray-500 uppercase">
                      Data Source
                    </th>
                    <th className="px-6 py-3 text-left text-xs font-medium text-gray-500 uppercase">
                      Url
                    </th>
                    <th className="px-6 py-3 text-left text-xs font-medium text-gray-500 uppercase">
                      Status
                    </th>
                    {/* <th className="px-6 py-3 text-left text-xs font-medium text-gray-500 uppercase">
                      ID
                    </th> */}
                    <th className="px-6 py-3 text-left text-xs font-medium text-gray-500 uppercase">
                      Created At
                    </th>
                  </tr>
                </thead>
                <tbody>
                  {datasources?.length > 0 ? (
                    datasources.map((dataSource, index) => (
                      <tr key={index} className="border-b">
                        <td className="px-6 py-4 whitespace-nowrap text-sm font-medium text-gray-900">
                          {dataSource.source_type}
                        </td>
                        <td
                          className="px-6 py-4 whitespace-nowrap text-sm text-gray-500"
                          title={dataSource.url}
                        >
                          {truncateString(dataSource.url, 80)}
                        </td>
                        <td className="px-6 py-4 whitespace-nowrap text-sm text-gray-500 capitalize">
                          <DataSourceStatus
                            dataSource={dataSource}
                          />
                          {/* <div className='flex justify-start flex-col'>
                                                    <div>
                                                        {['analyze','analyzing'].includes(dataSource.last_fetch_status) ? 'Analyzing 10/30 records' : dataSource.last_fetch_status}
                                                    </div>
                                                    <div className="w-full bg-gray-300 rounded-full h-2 mb-2 overflow-hidden">
                                                        <div
                                                            className="h-2 bg-yellow-500 rounded-l-full"
                                                            style={{ width: `50%` }}
                                                        />
                                                    </div>
                                                </div> */}
                        </td>
                        {/* <td className="px-6 py-4 whitespace-nowrap text-sm text-gray-500">
                          {dataSource.ds_id}
                        </td> */}
                        <td className="px-6 py-4 whitespace-nowrap text-sm text-gray-500">
                          {showDate(dataSource.last_fetch_date)}
                        </td>
                        {/* <td className="px-6 py-4 whitespace-nowrap text-sm text-gray-500">{moment(dataSource.last_fetch_date).format('dd MMM yyy')}</td> */}
                      </tr>
                    ))
                  ) : (
                    <tr>
                      <td
                        colSpan={4}
                        className="py-4 text-center whitespace-nowrap text-base font-medium text-gray-500 capitalize"
                      >
                        No Data Found
                      </td>
                    </tr>
                  )}
                </tbody>
              </table>
            </div>
            {isPagination && totalcount > 10 && (
              <div className="mt-4">
                <Paginator
                  first={first}
                  rows={perPage}
                  totalRecords={totalcount}
                  onPageChange={handlePageChange}
                  className="p-jc-center"
                />
              </div>
            )}
          </div>
        </div>
      </div>
    </div>
  );
};

export default DataSources;
